import type { Novidade } from './tipos';

/** Fase 2 (W4): Minha conta com nome, senha, sessões, verificação em duas etapas e fonte e tamanho do texto. */
export const novidadeConta: Novidade = {
  id: '2026-10-05-conta',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'Minha conta: segurança, fonte e tamanho do texto',
      resumo: 'Troque a senha, veja as sessões abertas, ative a verificação em duas etapas e escolha a fonte e o tamanho do texto.',
      passos: [
        'Em Minha conta, Perfil, edite o seu nome e veja os seus acessos reais em cada módulo.',
        'Em Segurança, troque a senha, encerre outras sessões e ative a verificação em duas etapas com o app autenticador.',
        'Em Aparência, escolha a fonte do texto e o tamanho (100, 110 ou 125%). Números seguem na fonte de largura fixa.',
      ],
    },
    en: {
      titulo: 'My account: security, font and text size',
      resumo: 'Change your password, see open sessions, turn on two-step verification and choose the text font and size.',
      passos: [
        'In My account, Profile, edit your name and see your real access in each module.',
        'In Security, change your password, end other sessions and turn on two-step verification with an authenticator app.',
        'In Appearance, choose the text font and size (100, 110 or 125%). Numbers stay in the fixed-width font.',
      ],
    },
    es: {
      titulo: 'Mi cuenta: seguridad, fuente y tamaño del texto',
      resumo: 'Cambia la contraseña, mira las sesiones abiertas, activa la verificación en dos pasos y elige la fuente y el tamaño del texto.',
      passos: [
        'En Mi cuenta, Perfil, edita tu nombre y mira tus accesos reales en cada módulo.',
        'En Seguridad, cambia la contraseña, cierra otras sesiones y activa la verificación en dos pasos con la app autenticadora.',
        'En Apariencia, elige la fuente del texto y el tamaño (100, 110 o 125%). Los números siguen en la fuente de ancho fijo.',
      ],
    },
  },
  imagens: [null, '/novidades/2026-10-05-conta/seguranca.webp', '/novidades/2026-10-05-conta/aparencia.webp'],
  treinamento: { curso: 'novidades' },
  rota: '/conta/seguranca',
};
